//src/components/shared/ClientOperationalGuard.tsx
import type { PropsWithChildren } from "react";

import { OperationalClientRequired } from "@/components/shared/OperationalClientRequired";
import { Skeleton } from "@/components/ui/skeleton";
import { useClientCompanyContext } from "@/hooks/useClientCompanyContext";

export function ClientOperationalGuard({ children }: PropsWithChildren) {
  const {
    hasSelectedClientCompany,
    isLoadingClientCompanies,
    selectedClientCompanyId,
  } = useClientCompanyContext();

  if (isLoadingClientCompanies) {
    return (
      <div className="space-y-4" aria-label="Carregando contexto do cliente">
        <Skeleton className="h-9 w-64" />
        <Skeleton className="h-24 w-full" />
        <Skeleton className="h-64 w-full" />
      </div>
    );
  }

  if (!hasSelectedClientCompany || !selectedClientCompanyId) {
    return <OperationalClientRequired />;
  }

  return (
    <div key={selectedClientCompanyId} className="contents">
      {children}
    </div>
  );
}
